import { Box } from '@mui/material'

interface SeloNovoProps {
  emLinhaPropria?: boolean
}

export function SeloNovo({ emLinhaPropria = false }: SeloNovoProps): JSX.Element {
  return (
    <Box
      component="span"
      sx={{
        typography: emLinhaPropria ? 'caption' : undefined,
        display: emLinhaPropria ? 'block' : 'inline-block',
        ml: emLinhaPropria ? 0 : 0.75,
        mt: emLinhaPropria ? 0.25 : 0,
        color: 'success.main',
        fontSize: emLinhaPropria ? undefined : '0.8em',
        fontWeight: 600,
        lineHeight: emLinhaPropria ? 1.4 : 1,
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
      }}
    >
      Novo
    </Box>
  )
}
